/* Livingston V28: iPad/iPadOS collection-filter compatibility fallback.
 * Livingston V29: compact the selected Product type after a guided choice.
 *
 * V28 keeps iPad filter application on a normal Shopify collection URL navigation.
 * V29 is presentation only: once exactly one Product type is selected, the full
 * chooser collapses to the selected type plus a Change control. It works on the
 * Menswear progressive flow and V25 automatic Shop by collections.
 */

if (!window.__livingstonIpadFilterFallbackV28) {
  window.__livingstonIpadFilterFallbackV28 = true;

  const isIPad =
    /iPad/.test(navigator.userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  if (isIPad) {
    function navigateFromFacetForm(component) {
      const form = component && component.querySelector('form');
      if (!(form instanceof HTMLFormElement)) return;

      const formData = new FormData(form);
      const sortBy = formData.get('sort_by');
      const hasSort = typeof sortBy === 'string' && sortBy !== '';
      const url = new URL(window.location.href);

      for (const key of [...url.searchParams.keys()]) {
        if (
          key.startsWith('filter.') ||
          key === 'page' ||
          key === 'section_id' ||
          (hasSort && key === 'sort_by')
        ) {
          url.searchParams.delete(key);
        }
      }

      for (const [key, value] of formData.entries()) {
        if (typeof value !== 'string' || key === 'page' || key === 'section_id') continue;
        if (!key.startsWith('filter.') || key === 'sort_by') continue;
        if (
          (key === 'filter.v.price.gte' || key === 'filter.v.price.lte') &&
          value.trim() === ''
        ) {
          continue;
        }
        if (value !== '') url.searchParams.append(key, value);
      }

      if (hasSort) url.searchParams.set('sort_by', sortBy);

      window.location.assign(url.toString());
    }

    function patchFacetComponent() {
      const FacetsForm = customElements.get('facets-form-component');
      if (!FacetsForm || !FacetsForm.prototype) return;

      const prototype = FacetsForm.prototype;
      if (prototype.__livingstonIpadV28Patched) return;
      if (typeof prototype.updateFilters !== 'function') return;

      prototype.__livingstonIpadV28Patched = true;
      prototype.__livingstonOriginalUpdateFiltersV28 = prototype.updateFilters;
      prototype.updateFilters = function () {
        navigateFromFacetForm(this);
      };
    }

    if (customElements.get('facets-form-component')) {
      patchFacetComponent();
    } else {
      customElements.whenDefined('facets-form-component').then(patchFacetComponent);
    }
  }
}

if (!window.__livingstonCompactSelectedProductTypeV29) {
  window.__livingstonCompactSelectedProductTypeV29 = true;

  let compactFrame = 0;

  function compactSelectedProductType() {
    compactFrame = 0;
    const group = document.querySelector(
      '#livingston-shop-by .livingston-shop-by__group--product-type'
    );
    if (!(group instanceof HTMLElement)) return;

    const activeTypes = group.querySelectorAll(
      '.livingston-shop-by__chip--product-type.is-active'
    );
    const existingChange = group.querySelector('[data-livingston-v29-change-type]');

    if (activeTypes.length !== 1) {
      group.classList.remove('livingston-shop-by__group--selected-compact');
      group.removeAttribute('data-livingston-v29-editing');
      if (existingChange instanceof HTMLElement) existingChange.remove();
      return;
    }

    if (group.dataset.livingstonV29Editing === 'true') {
      group.classList.remove('livingston-shop-by__group--selected-compact');
      if (existingChange instanceof HTMLElement) existingChange.remove();
      return;
    }

    const active = activeTypes[0];
    const options = group.querySelector('.livingston-shop-by__options');
    if (options instanceof HTMLElement && active instanceof HTMLElement && options.firstElementChild !== active) {
      options.prepend(active);
    }

    group.classList.add('livingston-shop-by__group--selected-compact');

    if (!(existingChange instanceof HTMLButtonElement)) {
      const change = document.createElement('button');
      change.type = 'button';
      change.className = 'livingston-shop-by-v29__change';
      change.dataset.livingstonV29ChangeType = '';
      change.textContent = 'Change';
      change.setAttribute('aria-label', 'Change product type');
      group.appendChild(change);
    }
  }

  function scheduleCompactSelectedProductType() {
    if (compactFrame) cancelAnimationFrame(compactFrame);
    compactFrame = requestAnimationFrame(compactSelectedProductType);
  }

  document.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;
      const change = event.target.closest('[data-livingston-v29-change-type]');
      if (!(change instanceof HTMLButtonElement)) return;

      const group = change.closest('.livingston-shop-by__group--product-type');
      if (!(group instanceof HTMLElement)) return;

      event.preventDefault();
      event.stopPropagation();
      group.dataset.livingstonV29Editing = 'true';
      group.classList.remove('livingston-shop-by__group--selected-compact');
      change.remove();
    },
    true
  );

  const startV29 = () => {
    scheduleCompactSelectedProductType();
    const target = document.getElementById('MainContent') || document.body;
    if (!(target instanceof HTMLElement)) return;

    const observer = new MutationObserver(() => scheduleCompactSelectedProductType());
    observer.observe(target, { subtree: true, childList: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startV29, { once: true });
  } else {
    startV29();
  }

  document.addEventListener('shopify:section:load', scheduleCompactSelectedProductType);
  window.addEventListener('popstate', scheduleCompactSelectedProductType);
}
